import React, { useState } from 'react';
import Modal from 'react-modal';
import { AxiosResponse } from 'axios';
import { TFreelancerData } from '../../types';
import LoadingSpinner from '../common/LoadingSpinner';
import { getErrorMessages } from '../../utils';
import { ErrorMessage } from '../common';
import { QuickActionItem } from '../common/quickActions';


type TConfirmMarkAsUnsuitableModalProps = {
    freelancer: TFreelancerData;
    isOpen: boolean;
    handleClose: () => void;
    onSave: () => void;
    isLoading: boolean;
    isUnsuitable: boolean;
    error: any;
}

export function ConfirmMarkAsUnsuitableModal({
    freelancer,
    isOpen,
    handleClose,
    onSave = null,
    isLoading,
    isUnsuitable,
    error,
}: TConfirmMarkAsUnsuitableModalProps) {


    return (
        <Modal
            className="cancel-worker-modal"
            isOpen={isOpen}
            onRequestClose={handleClose}
            contentLabel="Confirm shift"
            ariaHideApp={false}
        >
            { isUnsuitable
                ? <p className="modal-title">Cancel Found Own Job</p>
                : <p className="modal-title">Found Own Job</p>
            }
            <div className="cancel-worker-body">
                {isUnsuitable ? (
                    <p>
                        Are you sure that you wish to undo <b>{freelancer.full_name}</b> as
                        having found their own job? They will be able to utilise our app again
                        and receive job offers.
                    </p>
                ) : (
                    <p>
                        Are you sure that you would like to mark <b>{freelancer.full_name}</b> as
                        having found their own job? They will not be able to use our app
                        or register using the same email address or mobile number.<br/>
                    </p>
                )}
            </div>
            <button
                className="continue btn--round-big"
                onClick={onSave}
                type="button"
                disabled={isLoading}
            >
                {isLoading ? (
                    <LoadingSpinner
                        className="cancel-worker-spinner"
                        backgroundColor="white"
                    />
                ) : (
                    'CONFIRM'
                )}
            </button>
            {!isLoading && (
                <button className="back" onClick={handleClose} type="button">
                    CANCEL
                </button>
            )}
            {error
                ? <ErrorMessage message={error}/>
                : <></>}
        </Modal>
    );
}


type TMarkUnsuitableProps = {
    freelancer: TFreelancerData;
    notification?: any;
    onSave: (fields: any) => Promise<AxiosResponse>;
}

export default function MarkUnsuitable({
    freelancer,
    notification,
    onSave,
}: TMarkUnsuitableProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleIsUnsuitable = () => {
        setIsLoading(true);
        setError(null);

        const fields = { 'is_unsuitable': !freelancer.is_unsuitable };
        onSave(fields)
            .then(() => {
                setIsLoading(false);
                handleCloseModal();
                const successMessage = freelancer.is_unsuitable
                    ? `Successfully undo ${freelancer.full_name} as having found their own job.`
                    : `Successfully marked ${freelancer.full_name} as having found their own job.`;
                notification?.success('Success', successMessage);
            })
            .catch(err => {
                setError(getErrorMessages(err));
                setIsLoading(false);
            });

    };

    return (
        <>
            <QuickActionItem
                label={`${freelancer.is_unsuitable ? 'Cancel ' : ''} Found Own Job`}
                icon="icon-close2"
                onClick={handleOpenModal}
            />
            {isModalOpen && (
                <ConfirmMarkAsUnsuitableModal
                    freelancer={freelancer}
                    isOpen={isModalOpen}
                    handleClose={handleCloseModal}
                    onSave={handleIsUnsuitable}
                    isLoading={isLoading}
                    isUnsuitable={freelancer.is_unsuitable}
                    error={error}
                />
            )}
        </>
    );
}
